import React from 'react';
import {observer} from 'mobx-react'
import _ from 'lodash';
import { FormBean } from '../../datatypes';


class Banner extends React.Component<{formBean:FormBean},{}> {

  renderErrors = () => {
    return <div className={'contextualBannerOuter '}><div className={'contextualBannerInner '}>
      {Object.keys(this.props.formBean.contextualErrors).map(e => <div key={e}><i
          className="fas fa-exclamation-circle icon-banner-error"></i>{this.props.formBean.contextualErrors[e]}</div>)}
    </div></div>
  }
  render() {
    return (
        this.props.formBean && !_.isEmpty(this.props.formBean.contextualErrors) ?  this.renderErrors() : ''
    )
  }
}

export default observer(Banner);